import { createFileRoute } from "@tanstack/react-router";
import { PhonicsTrashPage } from "../../components/media/phonics/PhonicsTrashPage";

export const Route = createFileRoute("/media/phonics/trash")({
  component: PhonicsTrashPageRoute,
});

function PhonicsTrashPageRoute() {
  return <PhonicsTrashPage />;
}
